import React from 'react';
import useStyles from './styles';

interface IButtonFix {
    onClick: () => void;
    btnContent: string;
}

const ButtonFix: React.FC<IButtonFix> = ({ onClick, btnContent }) => {
  const classes = useStyles();
  return (
    <button onClick={() => onClick()} type="button" className={classes.buttonFix}>
      {btnContent}
    </button>
  );
};

export default ButtonFix;
